module.exports = __webpack_public_path__ + "static/media/picture.567bb06c.svg";